import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { IntegratedChatWidget } from './IntegratedChatWidget';
import './../../ChatbotStyles/FloatingChatbot.scss';

export const FloatingChatbot: React.FC = () => {
  const { useNewUI } = useSelector((state: RootState) => state.uiToggle);

  if (!useNewUI) {
    return null;
  }

  return (
    <div className="chat-widget-floating-container">
      <IntegratedChatWidget />
    </div>
  );
};
